import React, { useEffect, useRef, useState } from "react";

const POOL = [
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&h=120&fit=crop&crop=faces&auto=format",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&h=120&fit=crop&crop=faces&auto=format",
  "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&h=120&fit=crop&crop=faces&auto=format",
  "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=120&h=120&fit=crop&crop=faces&auto=format",
  "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=120&h=120&fit=crop&crop=faces&auto=format",
  "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=120&h=120&fit=crop&crop=faces&auto=format",
  "https://images.unsplash.com/photo-1521119989659-a83eee488004?w=120&h=120&fit=crop&crop=faces&auto=format",
  "https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=120&h=120&fit=crop&crop=faces&auto=format",
  "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=120&h=120&fit=crop&crop=faces&auto=format",
  "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=120&h=120&fit=crop&crop=faces&auto=format",
  "https://images.unsplash.com/photo-1463453091185-61582044d556?w=120&h=120&fit=crop&crop=faces&auto=format",
  "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=120&h=120&fit=crop&crop=faces&auto=format",
];

/**
 * Shows `count` avatars stacked; every `intervalMs` it swaps one position
 * with a different face from the pool. The slot that swaps cycles round-robin
 * so all positions get refreshed over time.
 */
export const RotatingAvatars = ({ count = 4, intervalMs = 2200, className = "", testId }) => {
  // Start with the first `count` images
  const [slots, setSlots] = useState(() => POOL.slice(0, count));
  const swapIdxRef = useRef(0);

  useEffect(() => {
    const id = setInterval(() => {
      setSlots((current) => {
        const idx = swapIdxRef.current % current.length;
        swapIdxRef.current += 1;
        // pick a portrait not currently shown
        const notShown = POOL.filter((p) => !current.includes(p));
        if (notShown.length === 0) return current;
        const next = notShown[Math.floor(Math.random() * notShown.length)];
        const copy = current.slice();
        copy[idx] = next;
        return copy;
      });
    }, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return (
    <div data-testid={testId} className={`flex -space-x-3 ${className}`}>
      {slots.map((src, i) => (
        <img
          key={`${i}-${src}`}
          src={src}
          alt=""
          loading="lazy"
          className="h-10 w-10 rounded-full border-2 border-white bg-slate-100 object-cover shadow-sm animate-[fadeIn_400ms_ease-out]"
        />
      ))}
    </div>
  );
};

export default RotatingAvatars;
